import { render, staticRenderFns } from "./Contact_Edit.vue?vue&type=template&id=224d698e&scoped=true&"
import script from "./Contact_Edit.vue?vue&type=script&lang=ts&"
export * from "./Contact_Edit.vue?vue&type=script&lang=ts&"
import style0 from "./Contact_Edit.vue?vue&type=style&index=0&id=224d698e&lang=scss&scoped=true&"
import style1 from "./Contact_Edit.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224d698e",
  null
  
)

export default component.exports